import ModuleConfig from '../Config';

const actions = ModuleConfig.Actions;
const endpoints = ModuleConfig.Endpoints;
const ShortUrl = ModuleConfig.Structures.ShortUrl;
const CRUDActions = ModuleConfig.CRUDActions;

export function getShortUrls(opts = { start: 0, limit: 0}) {
    return CRUDActions.getAll(actions.getAll, {
        ...opts,
        endpoint: endpoints.shortUrls,
        mapStructure: ShortUrl,
        errorNotification: "Short URL-urile nu au putut fi incarcate"
    });
}

export function getShortUrl(id) {
    return CRUDActions.getOne(actions.getOne, {
        id,
        endpoint: endpoints.shortUrl,
        mapStructure: ShortUrl,
        errorNotification: "Short URL-ul nu a putut fi incarcat"
    })
}

export function createShortUrl(values) {
    return CRUDActions.create(actions.create, {
        values,
        endpoint: endpoints.shortUrls,
        mapStructure: ShortUrl,
        successNotification: "Short URL-ul a fost creat",
        nextUrl: '/short-urls/',
    })
}

export function updateShortUrl(id, values) {
    return CRUDActions.update(actions.edit, {
        id,
        values,
        endpoint: endpoints.shortUrl,
        mapStructure: ShortUrl,
        successNotification: "Short URL-ul a fost modificat",
        nextUrl: '/short-urls/',
    })
}

export function deleteShortUrl(id) {
    return CRUDActions.remove(actions.delete, {
        id,
        endpoint: endpoints.shortUrl,
        successNotification: "Short URL-ul a fost sters",
        nextUrl: '/short-urls/'
    });
}
